import React from 'react';
import { COMPANY_INFO } from '../data/mockData';

export default function FloatingCTA() {
  return (
    <div className="fixed bottom-6 right-6 z-50 flex flex-col gap-3.5 items-center">
      {/* Phone Floating Button */}
      <a
        href={`tel:${COMPANY_INFO.phoneRaw}`}
        aria-label={`Ring til ${COMPANY_INFO.name} på ${COMPANY_INFO.phone}`}
        className="w-13 h-13 sm:w-14 sm:h-14 rounded-full bg-sky-600 hover:bg-sky-500 text-white shadow-xl hover:shadow-2xl hover:shadow-sky-500/30 flex items-center justify-center transition-all duration-300 ease-in-out hover:scale-110 active:scale-95 focus:outline-none focus:ring-4 focus:ring-sky-400/50 group"
        title={`Ring på ${COMPANY_INFO.phone}`}
      >
        <i className="fa-solid fa-phone text-lg sm:text-xl transition-transform duration-300 group-hover:rotate-12" aria-hidden="true" />
      </a>

      {/* Email Floating Button */}
      <a
        href={`mailto:${COMPANY_INFO.email}`}
        aria-label={`Send e-mail til ${COMPANY_INFO.email}`}
        className="w-13 h-13 sm:w-14 sm:h-14 rounded-full bg-slate-900 hover:bg-slate-800 text-sky-400 hover:text-white border border-slate-700/80 shadow-xl hover:shadow-2xl hover:shadow-slate-900/50 flex items-center justify-center transition-all duration-300 ease-in-out hover:scale-110 active:scale-95 focus:outline-none focus:ring-4 focus:ring-slate-600/50 group"
        title={`Send e-mail til ${COMPANY_INFO.email}`}
      >
        <i className="fa-solid fa-envelope text-lg sm:text-xl transition-transform duration-300 group-hover:scale-110" aria-hidden="true" />
      </a>
    </div>
  );
}
